<div class="container-cards">
  <form class="form-message" novalidate (submit)="$event.preventDefault()">
    <ml-card-container
      [icon]="'chat'"
      [title]="'application.chat.title' | translate"
      [class]="'row'"
      [isFullWidth]="true"
    >
      @if (!chatMessageResponseListError()) {
        <ml-chat
          [messages]="messageList()"
          [placeholder]="'application.chat.chat-placeholder' | translate"
          [height]="'40rem'"
          [dateFormat]="dateFormat"
        />
      } @else {
        Erreur
      }
      <div class="container-message">
        <ml-text-area-signal-input
          class="textarea"
          [id]="'message'"
          [formField]="chatForm.message"
          [placeholder]="'application.chat.message-placeholder' | translate"
          [maxlength]="1000"
        ></ml-text-area-signal-input>
        <button
          mat-button
          type="button"
          color="primary"
          class="button"
          [attr.aria-label]="'application.chat.send' | translate"
          (click)="submit()"
        >
          <div class="container-button">
            <ml-icon [iconName]="'send'" />
            <p class="button-content" [innerHTML]="'application.chat.send' | translate"></p>
          </div>
        </button>
      </div>
    </ml-card-container>
  </form>

  <ml-card-container
    [icon]="'chat'"
    [title]="'application.chat.documents.title' | translate"
    [class]="'row card-container-download'"
    [isFullWidth]="true"
  >
    <div class="container-download" #documentsContainer>
      @if ((documentHistory$ | async) && documentsList.length) {
        @for (document of documentsList; track document.externalId) {
          <div class="download-data">
            <ml-file-printing-button
              [label]="`application.chat.documents.${document.documentType}` | translate"
              [isLoading]="!!documentLoadingIds.get(document.externalId)"
              (clickEvent)="downloadFile(document)"
            />
            <span class="download-date">{{ document.sendDate | date: dateFormat + ' - HH:mm' }}</span>
          </div>
        }
      } @else {
        <p class="download-no-documents-text" [innerHTML]="'application.chat.documents.no-documents' | translate"></p>
      }
    </div>
  </ml-card-container>
</div>

<ml-status-message-popup-v2
  [popupInfo]="statusPopupElement"
  (closeEvent)="isDocumentDownloadingErrorPopup = false">
</ml-status-message-popup-v2>
